import React from 'react';
import { motion } from 'framer-motion';
import { SOAPS } from '@/lib/data';
import { ProductCard } from './ProductCard';
import { BundleCard } from './BundleCard';
import { Reveal, MaskedLines } from './motion/Reveal';
import { TID } from '@/constants/testIds';

const easeOut = [0.22, 1, 0.36, 1];

export const SoapsSection = () => {
  const individuals = SOAPS.filter((s) => s.category === 'soap');
  const bundles = SOAPS.filter((s) => s.category === 'soap-bundle');

  return (
    <section id="soaps" data-testid={TID.soapsSection} className="cw-section relative">
      <div className="cw-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
          <div>
            <Reveal>
              <span className="cw-label">01 — The Soaps</span>
            </Reveal>
            <MaskedLines
              className="font-heading mt-3 text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight"
              lines={[
                <>
                  Five bars. <span className="italic font-light">Slow cured.</span>
                </>,
              ]}
            />
          </div>
          <Reveal delay={0.1}>
            <p className="md:max-w-sm text-[var(--cw-muted)] text-sm leading-relaxed">
              Hand-poured in small batches with botanicals and cold-pressed oils.
              Four grown-up bars and one tear-free favourite for the little ones.
            </p>
          </Reveal>
        </div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-60px' }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.08, delayChildren: 0.1 } },
          }}
        >
          {individuals.map((p) => (
            <motion.div
              key={p.id}
              variants={{
                hidden: { opacity: 0, y: 30 },
                show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: easeOut } },
              }}
            >
              <ProductCard product={p} accent="blue" />
            </motion.div>
          ))}
        </motion.div>

        <Reveal delay={0.1}>
          <p className="mt-6 text-xs text-[var(--cw-muted)] italic max-w-2xl">
            * Each bar is hand-poured — actual soap shapes, colours and swirls may
            vary slightly from the images shown. That&apos;s the small-batch charm.
          </p>
        </Reveal>

        <div id="hampers" className="mt-20">
          <Reveal>
            <div className="flex items-center gap-3 mb-6">
              <span className="cw-label">Bundles &amp; gifts · pick any 4 soaps</span>
              <div className="flex-1 h-px bg-[var(--cw-border)]" />
            </div>
          </Reveal>
          <Reveal delay={0.05}>
            <div className="grid grid-cols-1 gap-6">
              {bundles.map((p) => (
                <BundleCard key={p.id} product={p} accent="yellow" />
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
